module.exports = __webpack_public_path__ + "img/lite-relax.43eef064.jpg";